import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import "./App.css";
import logoQWER from "./log_QWER.jpeg";
import timelineProfile from "./timeline-profile.jpg";
import endGif1 from "./end1.gif";
import endGif2 from "./end2.gif";
import endGif3 from "./end3.gif";
import { Analytics } from "@vercel/analytics/react";
import { useTranslation } from "react-i18next";
import i18n from "../src/lang/i18n";
import "./TestTimeline.css";
import "./modal.css";

const extractYouTubeID = (url) => {
  const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
  const match = url.match(regExp);
  return match && match[2].length === 11 ? match[2] : null;
};

const formatDate = (dateObject) => {
  if (dateObject && dateObject.$date) {
    return dateObject.$date.split("T")[0];
  }
  return "";
};

const isMobile = () => {
  return /Mobi|Android|iPhone/i.test(navigator.userAgent);
};

const getRandomEndGif = () => {
  const gifs = [endGif1, endGif2, endGif3];
  return gifs[Math.floor(Math.random() * gifs.length)];
};
// API로 팬캠 목록을 불러오는 헬퍼는 컴포넌트 내부에서 상태와 함께 사용한다

const NewBawige = ({ darkMode, toggleDarkMode }) => {
  const [items, setItems] = useState([]);
  const [allItems, setAllItems] = useState([]);
  const [page, setPage] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const loader = useRef(null);
  const scrollTimeout = useRef(null);
  const [endGif, setEndGif] = useState(getRandomEndGif());
  const [sortOrder, setSortOrder] = useState("asc");
  const [menuOpen, setMenuOpen] = useState(false);
  const [eventList, setEventList] = useState([]);
  const [selectedEvent, setSelectedEvent] = useState("");
  const [isEventListOpen, setIsEventListOpen] = useState(false);
  const { t } = useTranslation();

  const containerStyle = {
    backgroundColor: "rgba(18, 18, 18, 0.2)",
    minHeight: "100vh",
    color: "#ffffff",
  };

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
    const hamburger = document.querySelector(".hamburger");
    hamburger.classList.toggle("active");
  };

  const closeMenu = () => {
    setMenuOpen(false);
    const hamburger = document.querySelector(".hamburger");
    hamburger.classList.remove("active");
  };

  const itemsPerPage = 10;
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const API_KEY = process.env.REACT_APP_API_KEY;

  const toggleEventList = () => {
    setIsEventListOpen(!isEventListOpen);
  };

  // API에서 데이터 로드
  const fetchData = async (
    pageNum = 1,
    sort = sortOrder,
    festivalFilter = selectedEvent,
    limit = itemsPerPage,
  ) => {
    setIsLoading(true);
    try {
      const baseUrl = API_BASE_URL || "";
      const sortParam =
        (sort || "asc").toUpperCase() === "DESC" ? "DESC" : "ASC";
      let url = `${baseUrl}/apis/new?page=${pageNum}&limit=${limit}&sortBy=uploadDate:${sortParam}`;
      if (festivalFilter) {
        url += `&filter.tag=$eq:${encodeURIComponent(festivalFilter)}`;
      }

      const response = await fetch(url, {
        headers: API_KEY ? { "x-api-key": API_KEY } : {},
      });
      if (!response.ok) {
        throw new Error("데이터 로딩 오류, 관리자에게 문의해주세요");
      }
      const result = await response.json();

      if (pageNum === 1) {
        setItems(result.data || []);
        setAllItems(result.data || []);
      } else {
        setItems((prev) => [...prev, ...(result.data || [])]);
      }

      const current = result?.meta?.currentPage ?? pageNum;
      const total = result?.meta?.totalPages ?? current;
      setPage(current);
      setHasMore(current < total);
    } catch (error) {
      console.error("데이터 로딩 오류, 관리자에게 문의해주세요:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const loadMoreItems = async () => {
    if (isLoading || !hasMore) return;
    const nextPage = page + 1;
    setIsLoading(true);

    try {
      const delay = isMobile() ? 150 : 300;
      await new Promise((resolve) => setTimeout(resolve, delay));
      await fetchData(nextPage, sortOrder, selectedEvent);
    } finally {
      setIsLoading(false);
    }
  };

  const handleScroll = () => {
    if (scrollTimeout.current) {
      clearTimeout(scrollTimeout.current);
    }

    const debounceTime = isMobile() ? 100 : 150;

    scrollTimeout.current = setTimeout(() => {
      const scrollTop =
        window.pageYOffset || document.documentElement.scrollTop;
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;

      let scrollThreshold;
      if (isMobile()) {
        scrollThreshold = documentHeight * 0.5;
      } else {
        scrollThreshold = documentHeight - windowHeight - 100;
      }

      if (scrollTop >= scrollThreshold) {
        loadMoreItems();
      }
    }, debounceTime);
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => {
      window.removeEventListener("scroll", handleScroll);
      if (scrollTimeout.current) {
        clearTimeout(scrollTimeout.current);
      }
    };
  }, [isLoading, items, hasMore]);

  // 초기 로드: API 호출로 대체
  useEffect(() => {
    fetchData(1, sortOrder, selectedEvent, itemsPerPage);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const fetchEventList = async () => {
      try {
        const response = await fetch("/newFnasEPList.json");
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const data = await response.json();
        setEventList(data);
      } catch (error) {
        console.error("Error loading event list:", error);
      }
    };
    fetchEventList();
  }, []);

  const getYouTubeAppLink = (url) => {
    const videoId = extractYouTubeID(url);
    if (!videoId) return url;
    if (/Android/i.test(navigator.userAgent)) {
      return `intent://www.youtube.com/watch?v=${videoId}#Intent;package=com.google.android.youtube;scheme=https;end`;
    }
    return `https://www.youtube.com/watch?v=${videoId}`;
  };

  const handleThumbnailClick = (url) => {
    const link = isMobile() ? getYouTubeAppLink(url) : url;
    window.open(link, "_blank");
  };

  const handleEventFilter = (event) => {
    setSelectedEvent(event);
    setIsEventListOpen(false);
    fetchData(1, sortOrder, event);
  };

  const handleSort = () => {
    setSortOrder((prevOrder) => {
      const newOrder = prevOrder === "asc" ? "desc" : "asc";
      setPage(0);
      fetchData(1, newOrder, selectedEvent, itemsPerPage);
      return newOrder;
    });
  };

  const onChangeLangKO = () => {
    i18n.changeLanguage("ko");
  };

  const onChangeLangJP = () => {
    i18n.changeLanguage("jp");
  };

  const onChangeLangENG = () => {
    i18n.changeLanguage("en");
  };

  const clearEventFilter = (e) => {
    e.stopPropagation();
    setSelectedEvent("");
    setPage(0);
    fetchData(1, sortOrder, "", itemsPerPage);
  };

  return (
    <div className="App" style={containerStyle}>
      <h1>{t("newFan")}</h1>
      <h3>{t("newFanNotice")}</h3>

      <div className="lang-switch">
        <button
          className={`lang-btn ${i18n.language === "ko" ? "active" : ""}`}
          onClick={onChangeLangKO}
        >
          KR
        </button>
        <button
          className={`lang-btn ${i18n.language === "en" ? "active" : ""}`}
          onClick={onChangeLangENG}
        >
          EN
        </button>
        <button
          className={`lang-btn ${i18n.language === "jp" ? "active" : ""}`}
          onClick={onChangeLangJP}
        >
          JP
        </button>
      </div>
      <button className="sort-button" onClick={handleSort}>
        <span className="control-desktop-label">{sortOrder === "asc" ? t("sortNew") : t("sortOld")}</span>
        <span className="control-mobile-label">{t("sortLabel")}: {sortOrder === "asc" ? t("orderOld") : t("orderNew")}</span>
      </button>

      <div className="event-picker">
        <div className="event-list-header" onClick={toggleEventList}>
          <h3 className="event-list-title">
            <span className="control-desktop-label">{selectedEvent ? t(selectedEvent) : t("filterTitle")}</span>
            <span className="control-mobile-label">{t("categoryLabel")}: {selectedEvent ? t(selectedEvent) : t("categoryAll")}</span>
          </h3>
          <div className="header-controls">
            {selectedEvent && (
              <button
                className="clear-filter"
                onClick={clearEventFilter}
                aria-label="Clear filter"
              >
                ×
              </button>
            )}
            <span
              className={`event-list-toggle ${isEventListOpen ? "open" : ""}`}
            >
              ▼
            </span>
          </div>
        </div>
        <div className={`event-list-content ${isEventListOpen ? "open" : ""}`}>
          {eventList.map((event, index) => (
            <div
              key={index}
              className={`event-item ${
                selectedEvent === event ? "selected" : ""
              }`}
              onClick={() => handleEventFilter(event)}
            >
              {t(event)}
            </div>
          ))}
        </div>
      </div>

      <div className="test-timeline">
        {items.map((item, index) => {
          const videoId = extractYouTubeID(item.url);
          const thumbnailUrl = videoId
            ? `https://img.youtube.com/vi/${videoId}/0.jpg`
            : "";
          return (
            <div
              className={`test-timeline-item ${
                index % 2 === 0 ? "left" : "right"
              }`}
              key={item._id}
            >
              <div className="test-timeline-circle">
                <img
                  src={timelineProfile}
                  alt="QWER Logo"
                  className="test-timeline-circle-img"
                />
              </div>
              <div className="test-timeline-card">
                {thumbnailUrl && (
                  <img
                    src={thumbnailUrl}
                    alt={item.title}
                    className="thumbnail"
                    onClick={() => handleThumbnailClick(item.url)}
                  />
                )}
                <div className="test-timeline-title-container">
                  <h2>{item.title}</h2>
                </div>
                <div className="test-timeline-date">
                  {formatDate(item.uploadDate)}
                </div>
                <a
                  href={isMobile() ? getYouTubeAppLink(item.url) : item.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="test-timeline-link"
                >
                  {t("watch")}
                </a>
              </div>
            </div>
          );
        })}
        <div ref={loader} className="loader">
          {isLoading && (
            <div className="loading-spinner">
              <div className="spinner"></div>
              <p>{t("loading")}</p>
            </div>
          )}
        </div>

        <Analytics />
      </div>
      <footer className="footer">{t("footer")}</footer>
    </div>
  );
};

export default NewBawige;
